<footer class="footer" [ngClass]="{'footer--narrow-margin-top' : narrowMarginTop, 'theme--game': theme === 'game'}">


  <div class="footer__wrapper" tabindex="-1" id="footer">
    <a routerLink="/" class="footer__logo-wrapper">
      <brt-logo></brt-logo>

      <img class="footer__logo-game-white" src="/assets/img/berufsreise-logo-white.svg" alt="Berufsreise">
    </a>

    <div class="footer__logo-text">
      &copy; {{currentYear}} {{"FOOTER.DESIGNATION" | translate }}
    </div>

    <div class="footer__bottom-part">
      <div class="footer__links-wrapper">
        <a routerLink="/impressum" class="footer__link animline" [ngClass]="[theme === 'game' ? 'animline--white' : '']">{{"FOOTER.QUICKLINKS.IMPRINT" | translate }}</a>
        <a routerLink="/datenschutz" class="footer__link animline" [ngClass]="[theme === 'game' ? 'animline--white' : '']">{{"FOOTER.QUICKLINKS.PRIVACY" | translate }}</a>
        <a routerLink="/nutzungsbedingungen" class="footer__link animline" [ngClass]="[theme === 'game' ? 'animline--white' : '']">{{"FOOTER.QUICKLINKS.TERMS_OF_USE" | translate }}</a>
        <a routerLink="/barrierefreiheit" class="footer__link animline" [ngClass]="[theme === 'game' ? 'animline--white' : '']">{{"FOOTER.QUICKLINKS.ACCESSIBILITY" | translate }}</a>
        <a href="#" (click)="loadPrivacyWidget($event)" class="footer__link animline" [ngClass]="[theme === 'game' ? 'animline--white' : '']">{{"FOOTER.QUICKLINKS.COOKIE_SETTINGS" | translate }}</a>
        <a routerLink="/infos-angebote/faq" class="footer__link animline" [ngClass]="[theme === 'game' ? 'animline--white' : '']">{{"FOOTER.QUICKLINKS.FAQ" | translate }}</a>
      </div>
      <div class="footer__socials-wrapper">
        <a href="https://www.facebook.com/berufsreise" target="_blank" rel="nofollow" class="footer__social animline" [ngClass]="[theme === 'game' ? 'animline--white' : '']">
          <div class="footer__social-icon">
            <span class="icon-social-facebook"></span>
          </div>
          <div class="footer__social-label">{{"FOOTER.SOCIAL_MEDIA.FACEBOOK" | translate }}</div>
        </a>
        <a href="https://www.instagram.com/berufsreise.at" target="_blank" rel="nofollow" class="footer__social animline" [ngClass]="[theme === 'game' ? 'animline--white' : '']">
          <div class="footer__social-icon">
            <span class="icon-social-instagram"></span>
          </div>
          <div class="footer__social-label">{{"FOOTER.SOCIAL_MEDIA.INSTAGRAM" | translate }}</div>
        </a>
        <a href="https://www.youtube.com/channel/UCJ4gDPjwPqGFVLoVRscbEHw" target="_blank" rel="nofollow" class="footer__social animline" [ngClass]="[theme === 'game' ? 'animline--white' : '']">
          <div class="footer__social-icon">
            <span class="icon-social-youtube"></span>
          </div>
          <div class="footer__social-label">{{"FOOTER.SOCIAL_MEDIA.YOUTUBE" | translate }}</div>
        </a>
      </div>
    </div>
  </div>
</footer>
